import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { SpicyButton, Grid } from "@/components/customComponents";
import { Icon, IconVariants, IconSize } from "@next-platform/client-common-spicy-ui";

function scrollToTop(smooth = false) {
  if (smooth) {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  } else {
    document.documentElement.scrollTop = 0;
  }
}

const ScrollBackToTop = ({ top = 1000, smooth = true }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(document.documentElement.scrollTop >= top);
    };
    onScroll();
    document.addEventListener("scroll", onScroll);
    return () => document.removeEventListener("scroll", onScroll);
  }, [top]);

  return (
    <>
      {visible && (
        <Grid className="fixed bottom-[20px] right-[20px] z-[1000]">
          <SpicyButton variant="primary_small_short" color="secondary_strong" onPress={() => scrollToTop(smooth)} aria-label="scroll-back-to-top">
            <Icon icon={IconVariants.ARROW_UP} size={IconSize.XSMALL} />
          </SpicyButton>
        </Grid>
      )}
    </>
  );
};

ScrollBackToTop.propTypes = {
  top: PropTypes.number,
  smooth: PropTypes.bool,
};
export default ScrollBackToTop;
